import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ShopService } from '@app/services/shops/shop.service';
import { GiftUnlockExtension } from '@pdqdev/pdq-shared/dist/interfaces/ICheckoutExtensions';
import { DropdownOption } from '../../../../../../shared/config/extension-ui-options';
import { GiftUnlockMode } from '../../../../gift-unlock.component';

@Component({
  selector: 'gift-unlock-offer-coupon',
  templateUrl: './gift-unlock-offer-coupon.component.html',
  styleUrls: ['./gift-unlock-offer-coupon.component.scss'],
  standalone: false,
})
export class GiftUnlockOfferCouponComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() couponTypeOptions: DropdownOption[];
  @Input() shopCurrencySymbol: string;
  @Input() updateRequired: boolean;
  @Input() updateAppUrl: string;

  CouponType = GiftUnlockExtension.CouponType;

  constructor(private shopService: ShopService) {}

  get isMaxxAi(): boolean {
    return (
      this.shopService.isMaxxPredictEnabled && this.formGroup?.get('settings.mode')?.value === GiftUnlockMode.MAXX_AI
    );
  }

  get maxxAiGroup(): UntypedFormGroup {
    return this.formGroup?.get('settings.couponDetails.maxxAi') as UntypedFormGroup;
  }

  onUpdateAppPermissions(): void {
    window.open(this.updateAppUrl, '_blank');
  }
}
